import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

const Writing = () => {
  useEffect(() => {
    document.title = "Writing | Zoe-Alanah Robert";
  });
  return (
    <article className="about-main">
      <section>
        <h2 className="title-font pink-text">Writing</h2>
        <ul className="cv-list">
          <li><a href="https://asml.cyber.harvard.edu/2026/07/02/transparency-hub-is-now-open-source/" target="_blank" rel="noopener noreferrer"><i>Transparency Hub Is Now Open Source</i></a>, Applied Social Media Lab (2026)</li>
          <li><a href="https://asml.cyber.harvard.edu/2026/05/08/asmls-rightscon-2026-update/" target="_blank" rel="noopener noreferrer"><i>ASML's RightsCon 2026 Update</i></a>, Applied Social Media Lab (2026)</li>
        </ul>
      </section>
      <ScrollButton />
    </article>
  );
};

export default Writing;
